import React from 'react';
import PropTypes from 'prop-types';

import AppModal from '../Modals/AppModal';

import LeakGrowth from '../AlertsTabs/LeakGrowth';

export default class LeakGrowthModal extends React.Component {

  constructor(props) {
    super(props);

    this.onClose = this.onClose.bind(this);
  }

  onClose() {
    this.props.onClose();
  }

  getTransformedData() {
    const { data } = this.props;
    if (!data || !data.data || data.data.length === 0) {
      return null;
    }

    const x = data.data.map(item => new Date(item.SampleDateAndTime));
    const y = data.data.map(item => item.IntensityA);

    return {
      x,
      y,
      trendData: data.regressionData
    };
  }

  render() {
    const { isOpen, alertId } = this.props;
    const transformedData = this.getTransformedData();

    return (
      <AppModal
        closeIcon
        open={isOpen}
        onClose={this.onClose}
        maxWidth="sm"
        title={this.context.t('alert_id_param', { id: alertId })}
        content={
          <div style={{ minWidth: '520px' }}>
            <LeakGrowth
              data={transformedData}
            />
          </div>
        }
      />
    );
  }
}

LeakGrowthModal.contextTypes = {
  t: PropTypes.func.isRequired
};
